import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Shipment } from '@models/shipment.model';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';
import { FileItem } from '@models/file-item.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService, SharedService, Toaster } from '@services/index';
import { ShipmentService } from '@services/shipment.service';
import { LocalStorage } from 'ngx-webstorage';
import { AddShipmentFilesModalComponent } from '@app/shared/modals/add-shipment-files-modal/add-shipment-files-modal.component';
import { User } from '@models/user.model';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';


@Component({
  selector: 'ngx-shipment-files',
  templateUrl: './shipment-files.component.html',
  styleUrls: ['./shipment-files.component.scss'],
})
export class ShipmentFilesComponent implements OnInit {

	@Input() allowEdit: boolean = true;
	@Input() companyType: string;
	@Input() purchaseOrder: PurchaseOrderDto;
  	@Output() closed: EventEmitter<any> = new EventEmitter<any>();

	@LocalStorage() organizationId: string;
	user$: Observable<User>;
	shipments: Shipment[] = [];

	constructor(private shipmentService: ShipmentService,
    			private $shared: SharedService,
	            private $company: CompanyService,
	            private $modal: NgbModal,
              	public store: Store<{ user: User }>,
	            private $toaster: Toaster,
	) { }

	ngOnInit() {
    	this.user$ = this.store.select('user');
    	this.getShipments();
	}

	openFileModal(selectedType: string) {
		let fileTypes = this.$shared.shipmentFileTypes();

		event.stopPropagation();
		event.cancelBubble = true;
		const modalRef = this.$modal.open(AddShipmentFilesModalComponent, {
		  size: 'lg',
		  container: 'nb-layout',
		  keyboard: false,
		});

		modalRef.componentInstance.selectedType = selectedType;
		modalRef.componentInstance.purchaseOrderID = this.purchaseOrder.id;
		modalRef.componentInstance.files = this.purchaseOrder.files;
		modalRef.componentInstance.shipments = this.shipments;
		modalRef.componentInstance.fileTypes = fileTypes;
		modalRef.componentInstance.allowEdit = true;

		modalRef.result.then((res: any) => {
			this.closed.emit({ res });
		});
	}

	getShipments() {
	  this.shipmentService.getPurchaseOrderShipments(this.purchaseOrder.supplier_id, this.purchaseOrder.id)
	    .subscribe(shipments => {
	      this.shipments = shipments;
	    });
	}

	getShipmentDetailsText(id: string) {
		if (!id) {
			return '';
		}
		let shipment: Shipment = this.shipments.find(s => s.id === id);
		if (!shipment) {
			return '';
		}
		let text = 'Shipment: ' + shipment.tracking_code;
		if (shipment?.description) {
			text += '(' + shipment.description + ')';
		}
		return text;
	}
}
